export type TBlog = {
  image: string;
  title: string;
  language: string;
  url: string;
  minReadTime: number;
};

const blogs = [
  {
    image:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*SUXPN3OvP1D2uIuHDlobqA.png",
    title: "React-State Concept and LifeCycle Methods",
    language: "Turkish",
    url: "https://duyguevrim.medium.com/react-state-kavram%C4%B1-ve-lifecycle-methodlar-424ef496fbc2",
    minReadTime: 3
  },
  {
    image:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*BTWKPhr63I90PBgH5EVIXQ.png",
    title: "What is Redux? How to Use Redux in React?",
    language: "Turkish",
    url: "https://duyguevrim.medium.com/redux-nedir-reactta-redux-nas%C4%B1l-kullan%C4%B1l%C4%B1r-2fbcec4255db",
    minReadTime: 6
  },
  {
    image:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*JKp6A46ihy5-X_NlcIdvag.jpeg",
    title: "C# Fundamentals",
    language: "Turkish",
    url: "https://duyguevrim.medium.com/c-temelleri-561d6d06a2f1",
    minReadTime: 7
  },
];
export default blogs;
